module.exports = __webpack_public_path__ + "static/media/forever_tricolour_4.e1684b9c.jpg";